// What a clinician is told once Suggested Clinical Terms are accepted (useClinicalSuggestions).

import { english } from 'src/i18n/language';

// No genotype was added because the record is about a pregnancy (TGCLOUD-1868, decision 17): a Test
// or a Clinical Note opened for a fetus is the mother's record, and the server answers
// `genotypeSkipped: 'prenatal'` rather than write a document's genotype onto her.
export const PRENATAL_GENOTYPE_SKIPPED_TEXT =
  'No genotype was added to this person’s record: this record is about a pregnancy.';

/**
 * The snack shown after an accept: what was added, and, for a record about a pregnancy, that no
 * genotype was.
 *
 * @param {{ count?: { phenotypes?, genotypes?, diseases? }, genotypeSkipped?: string|null }} result
 *   the accept's answer, as useClinicalSuggestions.acceptSuggestions returns it
 * @param {Function} [t] the caller's t(); English when none is given
 * @returns {string}
 */
export function acceptedMessage(
  { count = {}, genotypeSkipped = null } = {},
  t = english
) {
  const parts = [];
  if (count.phenotypes)
    parts.push(t('{{count}} phenotype(s)', { count: count.phenotypes }));
  if (count.genotypes)
    parts.push(t('{{count}} genotype(s)', { count: count.genotypes }));
  if (count.diseases)
    parts.push(t('{{count}} disease(s)', { count: count.diseases }));
  const added = parts.length
    ? t('Added {{parts}} to the record', { parts: parts.join(', ') })
    : t('Nothing was added to the record');
  return genotypeSkipped === 'prenatal'
    ? `${added}. ${t(PRENATAL_GENOTYPE_SKIPPED_TEXT)}`
    : added;
}
